// extracted by mini-css-extract-plugin
export default {"container":"ssgrVt","loader":"Co6D0m","heading":"L7SFgb"};